export default "__VITE_ASSET__il8p$Awe__"